import {
    getOWAConnectedAccount,
    OWAConnectedAccountState,
    updateOWAConnectedAccountStatus,
} from 'owa-accounts-store';
import { orchestrator } from 'satcheljs';
import { initializeOwaConnectedAccount } from '../utils/initializeOwaConnectedAccount';
import { owaAccountStoreInitializationFailed } from '../actions/publicActions';
import { logUsage } from 'owa-analytics';
import { OwaConnectedAccountInitSource } from '../schema/OwaConnectedAccountInitSource';

orchestrator(owaAccountStoreInitializationFailed, actionMessage => {
    const { userIdentity, isRetry, accountProvider, error } = actionMessage;
    logUsage(
        'owaAccountStoreInitializationFailed',
        {
            error: error,
            accountProvider: accountProvider,
            isRetry: isRetry,
        },
        {
            isCore: true,
        }
    );
    if (!isRetry) {
        const account = getOWAConnectedAccount(userIdentity);
        initializeOwaConnectedAccount(account, OwaConnectedAccountInitSource.Init, true);
    } else {
        updateOWAConnectedAccountStatus(
            userIdentity,
            OWAConnectedAccountState.FailedToInitializeOWAConfig
        );
    }
});
